import get from "lodash/get";

export default class Customer {
  constructor(customerObject) {
    this.id = customerObject.id;
    this.customerObject = customerObject.attributes;
    this.relationships = customerObject.relationships;
  }

  getName() {
    return `${get(this.customerObject, "first_name")} ${get(
      this.customerObject,
      "last_name"
    )}`;
  }

  getPhoneNumber() {
    return get(this.customerObject, "phone_number");
  }

  getEmail() {
    const email = get(this.customerObject, "email", "");
    if (email.includes("anonymous") && email.includes("tymber")) return null;

    return email;
  }

  getStateResidency() {
    return get(this.customerObject, "state_residency");
  }
}
